<template>
  <div class="xjydsh">
    <Header title="学籍异动审核" type="0" route="/homeIndex"></Header>
    <van-search
      v-model="xsxx"
      shape="round"
      placeholder="请输入…"
      @input="getList"
    />
    <van-dropdown-menu>
      <van-dropdown-item v-model="xnxq.value" :options="columns.xnxq" />
    </van-dropdown-menu>
    <div class="xjydsh_content">
      <NOdata title="暂无学籍异动审核数据~" v-if="list.length == 0"></NOdata>
      <mode-list
        v-else
        v-for="(item, index) in list"
        :key="index"
        :item="item"
        @detail="detail"
      ></mode-list>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import modeList from "./mode/modeList.vue";
export default {
  components: { modeList },
  data() {
    return {
      xsxx: "",
      xnxq: {},
      columns: {},
      list: []
    };
  },
  watch: {
    "xnxq.value": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getList();
        }
      },
      deep: true
    }
  },
  created() {
    this.getXnxq();
  },
  methods: {
    detail(item) {
      this.$router.push({
        path: "/xjydsh/detail",
        query: {
          ywinstanceid: item.ywinstanceid,
          ywcode: item.ywcode
        }
      });
    },
    async getList() {
      const res = await Api.getXjydShList({
        xnxqid: this.xnxq.value, xsxx: this.xsxx 
      });
      if (res.code == 1) {
        this.list = res.data;
      }
    },
    async getXnxq() {
      const res = await Api.findDictionry({ zzdtype: "xnxq"});
      if (res.code == 1) {
        this.columns.xnxq = res.data.xnxq.map((item, index) => {
          if (item.isdqxq === "1") {
            this.xnxq = {
              text: item.xqmc,
              value: item.xnxq01id
            };
          }
          return {
            text: item.xqmc,
            value: item.xnxq01id
          };
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.xjydsh {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  .xjydsh_content {
    padding: 10px 15px 0;
    height: calc(~"100% - 112px");
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/index.vue